/**
 * Listing Header DOM Component
 *
 * Creates the sticky header element for the listing sheet, containing the title and two optional
 * controls — both hidden by default, shown only when the active chip's content needs them:
 *  - A back button (left), shown only by the Sold Full List view (NHS20-8826/8828,
 *    VIEW_SOLD_FULL_LIST in plugins/listView.plugin.js).
 *  - A "See All" button (right), shown by the Sold listing itself once there are more than 10
 *    sold homes (NHS20-8826) — lives here, not in the scrollable content area below, so it's
 *    reachable without scrolling on mobile.
 * Every other chip's listing content never calls either show*() method, so both stay absent.
 *
 * @module nativeInteractiveSiteMap/components/listingHeader.dom
 */

import fastdom from 'fastdom';
import createBackButton from './backButton.dom';
import createSeeAllButton from './seeAllButton.dom';
import createListingTitle from './listingTitle.dom';

export default function createListingHeader() {
  const headerElement = document.createElement('div');

  const gridClasses = [
    'nhs-c-native-interactive-site-map__listing-header',
    'nhs-mq-native-interactive-site-map__listing-header-medium',
  ];

  headerElement.className = gridClasses.join(' ');
  headerElement.setAttribute('data-listing-header', '');

  const backButton = createBackButton();
  backButton.hide();
  headerElement.appendChild(backButton.getElement());

  const titleComponent = createListingTitle();
  headerElement.appendChild(titleComponent.getElement());

  const seeAllButton = createSeeAllButton();
  seeAllButton.hide();
  headerElement.appendChild(seeAllButton.getElement());

  return {
    getElement() {
      return headerElement;
    },
    setText(text) {
      titleComponent.setText(text);
    },
    showBackButton() {
      backButton.show();
    },
    onBackClick(callback) {
      backButton.onClick(callback);
    },
    showSeeAllButton() {
      seeAllButton.show();
    },
    hideSeeAllButton() {
      seeAllButton.hide();
    },
    remove() {
      backButton.remove();
      seeAllButton.remove();
      fastdom.mutate(() => {
        headerElement.remove();
      });
    },
  };
}
